import React from 'react'
import '../institute.css'
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import AddStudents from './AddStudents';
import AddTeacher from './AddTeacher';

function ManageUser() {
    return (
        <>
            <div className='text-center w-full text-2xl'>
                Coming soon
            </div>
            {/* <Tabs className="managerUserTabs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <TabList className="w-full flex justify-center">
                                <Tab className="text-gray-400  px-3 cursor-pointer mb-2 relative text-2xl">
                                    Add Students
                                </Tab>
                                <Tab className="text-gray-400  px-3 cursor-pointer mb-2 relative text-2xl">
                                    Add Teachers
                                </Tab>
                            </TabList>
                        </div>
                        <div className="col-md-12">
                            <TabPanel>
                                <div className="addStudent-wrapper">
                                    <AddStudents/>

                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="addTeacher-wrapper">
                                    <AddTeacher/>
                                </div>
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </Tabs> */}
        </>
    )
}

export default ManageUser
